<template>
  <el-dialog
    ref="dialogRef"
    :visible.sync="dialogVisible"
    width="288px"
    :before-close="cancel"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :append-to-body="true"
  >
    <div class="box">
      <i class="iconfont icon-guanbi1" @click="cancel"></i>
      <div class="title">头像设置</div>
      <canvas id="imgCanvas" ref="imgCanvas" class="image-box" width="600" height="600" @mousedown="imgMousedown"></canvas>
      <div class="progress-bar">
        <div class="left" @click="changeStepRatio('decrease')"><i class="el-icon-minus"></i></div>
        <div ref="step" class="step">
          <div
            :style="{
              transform: `translateX(${stepTranslateX}px)`
            }"
            class="step-box"
            @mousedown="stepBoxMousedown"
          ></div>
        </div>
        <div class="right" @click="changeStepRatio('increase')"><i class="el-icon-plus"></i></div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="item-right" style="margin-right: 16px">
        <!-- .GIF .gif-->
        <el-upload
          class="upload-demo"
          :show-file-list="false"
          accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG"
          :headers="headers"
          :action="uploadUrl"
          :before-upload="handleUploadBefore"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadError"
        >
          <el-button :loading="uploadLoading" style="padding: 0; width: 90px; height: 32px">本地上传</el-button>
        </el-upload>
      </div>
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" :loading="saveLoading" style="padding: 0; width: 64px" @click="save">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from "axios"
import { getToken } from "@/utils/auth"
import { apiStaffStaffImage } from "@/api/user"
const baseUrl = process.env.NODE_ENV === "development" ? "" : process.env.VUE_APP_BASE_API
export default {
  data() {
    this.headers = { Authorization: getToken(), "X-ct-sso": getToken() }
    // this.drawImageCanvas = throttle(this.drawImageCanvas, 30)
    return {
      uploadUrl: `${baseUrl}/api/mds/oss/upload`,
      stepTranslateX: 0,
      saveLoading: false,
      uploadLoading: false,
      stepRatio: 1,
      // oldStepRatio: 1,
      imgTranslateX: 0,
      imgTranslateY: 0,
      // oldImgTranslateY: 0,
      canvas: null,
      mouseXY: {
        x: 0,
        y: 0
      }, // 鼠标坐标
      mouseType: null, // step  滑块 img 图片
      dialogVisible: false,
      imgUrl: require("@/assets/base/haveNewIcon.png")
    }
  },
  mounted() {
    document.addEventListener("mousemove", e => {
      this.mousemove(e)
    })
    document.addEventListener("mouseup", e => {
      this.mouseup(e)
    })
    // requestAnimationFrame(() => {

    // })
    this.$refs.dialogRef.rendered = true
  },
  destroyed() {
    document.removeEventListener("mousemove", e => {
      this.mousemove(e)
    })
    document.removeEventListener("mouseup", e => {
      this.mouseup(e)
    })
  },
  methods: {
    initDrawImageCanvas() {
      this.stepTranslateX = 0
      this.stepRatio = 1
      this.imgTranslateX = 0
      this.imgTranslateY = 0
      this.mouseXY = {
        x: 0,
        y: 0
      }
      this.drawImageCanvas()
    },
    drawImageCanvas() {
      const canvas = this.$refs.imgCanvas
      const ctx = canvas.getContext("2d")
      const img = new Image()
      img.crossOrigin = "*"
      img.src = this.imgUrl
      // img.setAttribute("crossOrigin", "anonymous")
      img.onload = e => {
        const width = img.width
        const height = img.height
        let canvasImgWidth = 0
        let canvasImgHeight = 0
        if (height >= width) {
          canvasImgWidth = canvas.width
          canvasImgHeight = canvas.height + ((height - width) / width) * canvas.height
        } else {
          canvasImgWidth = canvas.width + ((width - height) / height) * canvas.width
          canvasImgHeight = canvas.height
        }
        canvasImgWidth = canvasImgWidth * this.stepRatio
        canvasImgHeight = canvasImgHeight * this.stepRatio
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        // this.drawImageCanvas()
        // if (
        //   Math.abs(this.imgTranslateX) > Math.abs(-(canvasImgWidth - canvas.width) / 2) ||
        //   Math.abs(this.imgTranslateY) > Math.abs(-(canvasImgHeight - canvas.height) / 2)
        // ) {
        //   this.imgTranslateX = this.oldImgTranslateX
        //   this.imgTranslateY = this.oldImgTranslateY
        // } else {
        //   this.oldImgTranslateX = this.imgTranslateX
        //   this.oldImgTranslateY = this.imgTranslateY
        // }
        if (Math.abs(this.imgTranslateX) > Math.abs(-(canvasImgWidth - canvas.width) / 2)) {
          this.imgTranslateX = this.imgTranslateX > 0 ? (canvasImgWidth - canvas.width) / 2 : -(canvasImgWidth - canvas.width) / 2
        }
        if (Math.abs(this.imgTranslateY) > Math.abs(-(canvasImgHeight - canvas.height) / 2)) {
          this.imgTranslateY = this.imgTranslateY > 0 ? (canvasImgHeight - canvas.height) / 2 : -(canvasImgHeight - canvas.height) / 2
        }
        ctx.drawImage(
          img,
          -(canvasImgWidth - canvas.width) / 2 + this.imgTranslateX,
          -(canvasImgHeight - canvas.height) / 2 + this.imgTranslateY,
          canvasImgWidth,
          canvasImgHeight
        )
      }
    },
    cancel() {
      this.dialogVisible = false
    },
    show(data = {}, isShow = true) {
      this.imgUrl = data.imgUrl + "?t=" + new Date().getTime()
      // this.imgUrl = "https://fc1tn.baidu.com/it/u=3839012747,1220589487&fm=202"
      this.dialogVisible = isShow
      this.$nextTick(() => {
        this.initDrawImageCanvas()
      })
    },
    setMouseXY(x, y) {
      this.mouseXY = {
        x: x,
        y: y
      }
    },
    mousemove(e) {
      if (this.mouseType === "step") {
        this.stepBoxMousemove(e)
      }
      if (this.mouseType === "img") {
        this.imgMousemove(e)
      }
    },
    changeStepRatio(type) {
      let diffX = type === "increase" ? 10 : -10
      const stepRect = this.$refs.step.getBoundingClientRect()
      const width = stepRect.width
      if (this.stepTranslateX + diffX <= 0) {
        diffX = 0 - this.stepTranslateX
      }
      if (this.stepTranslateX + diffX >= width - 18) {
        diffX = width - 18 - this.stepTranslateX
      }
      this.changeStepPosition(diffX)
    },
    // 改变滑块位置
    changeStepPosition(diffX) {
      const stepRect = this.$refs.step.getBoundingClientRect()
      const width = stepRect.width
      this.stepTranslateX += diffX
      this.stepRatio = (this.stepTranslateX / (width - 18)) * 5 + 1
      this.drawImageCanvas()
      // if (this.stepRatio / this.oldStepRatio < 1) {
      //   this.imgTranslateX = this.imgTranslateX * (this.stepRatio / this.oldStepRatio)
      //   this.imgTranslateY = this.imgTranslateY * (this.stepRatio / this.oldStepRatio)
      // }
    },
    stepBoxMousemove(e) {
      const eventX = e.x || e.pageX
      const eventY = e.y || e.pageY
      const stepRect = this.$refs.step.getBoundingClientRect()
      const width = stepRect.width
      // const height = stepRect.height
      const { x } = this.mouseXY
      const diffX = eventX - x
      this.setMouseXY(eventX, eventY)
      if (this.stepTranslateX + diffX > 0 && this.stepTranslateX + diffX < width - 18) {
        this.changeStepPosition(diffX)
      }
    },

    imgMousemove(e) {
      const eventX = e.x || e.pageX
      const eventY = e.y || e.pageY
      const { x, y } = this.mouseXY
      const diffX = eventX - x
      const diffY = eventY - y
      this.setMouseXY(eventX, eventY)
      this.imgTranslateX += diffX
      this.imgTranslateY += diffY
      this.drawImageCanvas()
    },
    imgMousedown(e) {
      this.mouseType = "img"
      this.setMouseXY(e.x || e.pageX, e.y || e.pageY)
    },
    stepBoxMousedown(e) {
      this.mouseType = "step"
      this.setMouseXY(e.x || e.pageX, e.y || e.pageY)
    },
    mouseup(e) {
      this.mouseType = null
      // this.oldStepRatio = this.stepRatio
    },
    // 上传之前校验文件大小
    handleUploadBefore(file) {
      this.uploadLoading = true
      const isLt2M = file.size / 1024 / 1024 < 20
      if (!isLt2M) {
        this.$message.warning(`图片大小不能超过 ${20}MB!`)
        this.uploadLoading = false
        return false
      }
    },
    // 上传失败
    handleUploadError(err, file, fileList) {
      if (err) console.log(err)
      this.$message.warning("上传出错, 请稍后再试")
      this.uploadLoading = false
    },
    // 上传成功
    async handleUploadSuccess(response, file, fileList) {
      if (response.code != 0) return
      this.imgUrl = response.data.url
      this.uploadLoading = false
      this.initDrawImageCanvas()
      // const { code } = await apiStaffStaffImage({ staffImage: response.data.url })
      // if (code != 0) return this.$message.error("修改头像失败")
      // this.formInfo.staffImage = response.data.url
      // this.$emit("changeHeaderImage", response.data.url)
    },
    save() {
      if (this.saveLoading) return
      const canvas = this.$refs.imgCanvas
      const dataURL = canvas.toDataURL("image/png")
      this.dataURLtoFile(dataURL, "upload.png")
    },
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
      var arr = dataurl.split(",")
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      const file = new File([u8arr], filename, { type: mime })
      this.uploadImage(file) // 图片上传
    },
    async uploadImage(file) {
      const formData = new FormData()
      formData.append("file", file)
      this.saveLoading = true
      axios
        .post(this.uploadUrl, formData, {
          headers: { Authorization: getToken(), "X-ct-sso": getToken() }
        })
        .then(async res => {
          if (res.status !== 200) return this.$message.error(res.statusText)
          const { data, code } = res.data
          if (code != 0) return this.$message.error("保存失败")
          try {
            const resImage = await apiStaffStaffImage({ staffImage: data.url })
            if (resImage.code != 0) return this.$message.error("修改头像失败")
            this.cancel()
            this.$emit("changeHeaderImage", data.url)
          } finally {
            this.saveLoading = false
          }
        })
        .catch(error => {
          console.log({ error })
          this.saveLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  height: 354px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon-guanbi1 {
    position: absolute;
    right: 16px;
    top: 16px;
    font-size: 12px;
    color: #999999;
    cursor: pointer;
  }

  .title {
    margin: 24px 0 24px;
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }

  .image-box {
    width: 240px;
    height: 240px;
    user-select: none;

    .image-box-background {
      width: 100%;
      height: 100%;
      object-fit: cover;
      user-select: none;
    }
  }

  .progress-bar {
    display: flex;
    width: calc(100% - 48px);
    height: 16px;
    background: #ffffff;
    border: 1px solid #e7e9ec;
    margin: 12px;
    justify-content: space-between;

    .left,
    .right {
      width: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      > i {
        font-weight: 600;
        font-size: 10px;
        user-select: none;
      }
    }

    .left {
      border-right: 1px solid #e7e9ec;
    }

    .right {
      border-left: 1px solid #e7e9ec;
    }

    .step {
      padding: 1px;
      flex: 1;

      .step-box {
        width: 16px;
        height: 100%;
        background: #d9d9d9;
        cursor: pointer;
        user-select: none;
      }
    }
  }
}

.dialog-footer {
  display: flex;
  width: 100%;
}
::v-deep .el-dialog__header {
  display: none;
}

::v-deep .el-dialog__body {
  padding: 0;
}
</style>
